define("powergen/routes/index",
  [],
  function() {
    "use strict";
    var IndexRoute;

    IndexRoute = Ember.Route.extend({
      activate: function() {
        if (!this.get('manager')["static"]) {
          return this.controllerFor('index').startTimer();
        }
      },
      deactivate: function() {
        if (!this.get('manager')["static"]) {
          return this.controllerFor('index').stopTimer();
        }
      },
      model: function() {
        var _this = this;
        if (!this.get('manager')["static"]) {
          return Ember.RSVP.Promise(function(resolveModel, rejectModel) {
            var promises;
            promises = {
              scores: Ember.RSVP.Promise(function(resolve, reject) {
                return _this.get('store').findQuery('score', {
                  type: 'top'
                }).then(function(scores) {
                  return resolve(scores);
                });
              })
            };
            return Ember.RSVP.hash(promises).then(function(promises) {
              var model;
              model = Ember.Object.create({
                scores: promises.scores
              });
              return resolveModel(model);
            });
          });
        }
      },
      afterModel: function(model) {
        var indexController, lastScore;
        if (this.get('manager')["static"]) {
          this.transitionTo('systems');
          return;
        }
        indexController = this.controllerFor('index');
        model.get('scores').forEach(function(score) {
          return score.set('highlighted', false);
        });
        lastScore = model.get('scores').findBy('id', this.get('manager.lastScoreId'));
        if (lastScore) {
          lastScore.set('highlighted', true);
          return indexController.setProperties({
            'lastScoreWasInTop': true
          });
        } else {
          return indexController.setProperties({
            'lastScoreWasInTop': false
          });
        }
      }
    });


    return IndexRoute;
  });